import { useContext } from "react";
import { ChatMessagesContext } from "../context/ChatMessagesContext.js";
const useChatMessagesContext = ()=>{
    const context = useContext(ChatMessagesContext);
    if (!context) throw new Error('useMessageContext must be used within a MessageProvider');
    return context;
};
export { useChatMessagesContext };
